import React from 'react';

import PropTypes from 'prop-types';

import Divider from '@adsk/alloy-react-divider';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';
import { InfoPopover } from '@adsk/alloy-react-tooltip';
import { SideNavigationItem } from '@adsk/alloy-side-navigation';

/**
 * Custom side navigation item to show actual navigation item ("Configuration") along with "Template" header
 */
const ProjectTemplateSettingsSideNavigationItem = ({
  showTemplatesDivider,
  ...props
}) => {
  const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));
  return (
    <>
      <SideNavigationItem
        {...props}
        style={{ ...props.style, margin: '12px 0' }}
      />
      {showTemplatesDivider && (
        <Divider
          style={{
            width: 'auto',
            margin: '0 16px',
          }}
        />
      )}
      {showTemplatesDivider && !props.collapsed && (
        <div
          css={[
            {
              color: theme.colors.charcoal800,
              display: 'flex',
              alignItems: 'center',
              fontWeight: 'bold',
              margin: '16px 14px 12px',
              textTransform: 'uppercase',
            },
          ]}
        >
          <span>{T.translate('TEMPLATE')}</span>
          <InfoPopover
            message={
              <div css={[[{ whiteSpace: 'normal' }]]}>
                <div css={[{ fontWeight: 'bold', marginBottom: 4 }]}>
                  {T.translate('SET_UP_TEMPLATE')}
                </div>
                {T.translate('SET_UP_TEMPLATE_DESC')}
              </div>
            }
            placement={InfoPopover.PLACEMENTS.LEFT}
            size={14}
            style={{ lineHeight: 0, padding: '0 10px' }}
          />
        </div>
      )}
    </>
  );
};

ProjectTemplateSettingsSideNavigationItem.propTypes = {
  ...SideNavigationItem.propTypes,
  showTemplatesDivider: PropTypes.bool,
};

export default ProjectTemplateSettingsSideNavigationItem;
